import React, { FC } from 'react'

import CurrentProgramInfo from '../components/CurrentProgramInfo'
import ProgramCard from '../components/ProgramCard'
import SettingsSidebar from '../components/SettingsSidebar'

import { PageLayout } from 'Components'
import { routes } from 'Config'

const ProgramSettingsPage: FC = () => {
  return (
    <PageLayout variant="smallcircle">
      <div className="container max-900">
        <div className="row">
          <SettingsSidebar />

          <div className="col-12 col-lg-8">
            <h1>Einstellungen</h1>

            <h2 className="mt-4">Mein Programm</h2>

            <CurrentProgramInfo />

            <ProgramCard title="Neustart: Gewicht abnehmen" onClick={routes.profile.restartLoseWeight}>
              Sie haben sich für einen Neustart entschieden. Um Ihnen den Prozess zu erleichtern, ist der Fragebogen mit
              den Werten Ihres letzten Programmes bereits ausgefüllt.
            </ProgramCard>

            <ProgramCard title="Neustart: Gewicht halten" onClick={routes.profile.restartKeepWeight}>
              Sie haben sich für einen Neustart entschieden. Um Ihnen den Prozess zu erleichtern, ist der Fragebogen mit
              den Werten Ihres letzten Programmes bereits ausgefüllt.
            </ProgramCard>
          </div>
        </div>
      </div>
    </PageLayout>
  )
}

export default ProgramSettingsPage
